// extracted by mini-css-extract-plugin
export default {"root":"rW1Zr","item":"RD3ma","reverse":"H3sz6","button":"_3120P","subheading":"_6RU7K","bullet":"_3zLKf"};